
import { useState } from "react";

/**
 * Hook to manage individual action button state (hover, deselected)
 */
export const useActionButtonState = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isDeselected, setIsDeselected] = useState(false);

  const onMouseEnter = () => setIsHovered(true);
  
  const onMouseLeave = () => {
    setIsHovered(false);
    setIsDeselected(false);
  };

  return {
    isHovered,
    isDeselected,
    setIsHovered,
    setIsDeselected,
    onMouseEnter,
    onMouseLeave
  };
};
